(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('template-product')) return;

    var productSection = document.querySelector('.product-section[data-product-handle]');
    var nativeButton = productSection && productSection.querySelector('[data-add-to-cart]');
    if (!productSection || !nativeButton) return;

    var header = document.querySelector('#HeaderWrapper, .header-wrapper, .header-sticky-wrapper, .site-header');
    var handle = productSection.dataset.productHandle;
    var product;
    var bar = document.createElement('aside');
    bar.className = 'dv-pdp-sticky-add';
    bar.setAttribute('aria-label', 'Quick add product');
    bar.innerHTML = '<img class="dv-pdp-sticky-add__image" alt=""><div class="dv-pdp-sticky-add__details"><p class="dv-pdp-sticky-add__title"></p><p class="dv-pdp-sticky-add__price"></p></div><button type="button" class="dv-pdp-sticky-add__button" data-dv-quick-add-handle="' + handle.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '">QUICK ADD</button>';
    document.body.appendChild(bar);

    var image = bar.querySelector('.dv-pdp-sticky-add__image');
    var title = bar.querySelector('.dv-pdp-sticky-add__title');
    var price = bar.querySelector('.dv-pdp-sticky-add__price');
    title.textContent = productSection.dataset.productTitle || document.title;
    image.src = (document.querySelector('.product__photo img, .product-single__photo img, .product-image-main img') || {}).currentSrc || (document.querySelector('.product__photo img, .product-single__photo img, .product-image-main img') || {}).src || '';

    function formatMoney(cents) {
      if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      return '$' + (cents / 100).toFixed(2);
    }

    function selectedVariant() {
      if (!product) return null;
      var selected = [];
      product.options.forEach(function (optionName, index) {
        var inputs = productSection.querySelectorAll('[name^="options["]');
        var found;
        inputs.forEach(function (input) {
          if (found || input.name !== 'options[' + optionName + ']') return;
          if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') found = input.value;
        });
        selected[index] = found;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return !selected[index] || value === selected[index]; });
      }) || product.variants[0];
    }

    function refreshDetails() {
      var variant = selectedVariant();
      if (!variant) return;
      price.textContent = formatMoney(variant.price);
      var variantImage = variant.featured_image && variant.featured_image.src;
      if (variantImage) image.src = variantImage;
    }

    function syncPosition() {
      if (!header) { document.documentElement.style.setProperty('--dv-pdp-sticky-top', '0px'); return; }
      var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--dv-pdp-sticky-top', bottom + 'px');
    }

    function syncVisibility() {
      var rect = nativeButton.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
      syncPosition();
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { product = data; refreshDetails(); })
      .catch(function () { price.textContent = productSection.querySelector('[data-product-price]')?.textContent?.trim() || ''; });

    productSection.addEventListener('change', refreshDetails);
    productSection.addEventListener('variant:change', refreshDetails);
    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);
    syncVisibility();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
